/**
 * Prefixes a same-origin storefront path with the active market/locale root
 * (e.g. `/en-ca`) when it is missing.
 *
 * Section Rendering API requests resolve market + currency from the request
 * path, so a URL without the locale root renders in the default market. Product
 * URLs coming from Liquid already carry the root, but URLs coming from
 * third-party markup (e.g. Searchspring recommendations) do not.
 *
 * @param {string} url - Absolute or root-relative storefront URL
 * @returns {string} - URL with the locale root applied, in its original form
 */
export default function localizeUrl(url) {
  if (!url) {
    return url;
  }

  const root = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '');
  if (!root) {
    return url;
  }

  let parsed;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return url;
  }

  if (parsed.origin !== window.location.origin) {
    return url;
  }

  if (parsed.pathname === root || parsed.pathname.startsWith(`${root}/`)) {
    return url;
  }

  parsed.pathname = `${root}${parsed.pathname}`;

  return /^https?:\/\//i.test(url)
    ? parsed.toString()
    : `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
